import French from './fr-FR.json'
import English from './en-US.json'
import Spanish from './es-SP.json'
import FrenchCanadian from './fr-CA.json'
import Polish from './pl-PL.json'
import German from './de-DE.json'
import Portuguese from './pt-PT.json'
import Italian from './it-IT.json'
import Dutch from './nl-NL.json'
import EnglishDash from '@vmockinc/dashboard/src/languages/en-US.json'
import FrenchDash from '@vmockinc/dashboard/src/languages/fr-FR.json'
import SpanishDash from '@vmockinc/dashboard/src/languages/es-SP.json'
import FrenchCanadianDash from '@vmockinc/dashboard/src/languages/fr-CA.json'
import PolishDash from '@vmockinc/dashboard/src/languages/pl-PL.json'
import GermanDash from '@vmockinc/dashboard/src/languages/de-DE.json'
import PortugueseDash from '@vmockinc/dashboard/src/languages/pt-PT.json'
import ItalianDash from '@vmockinc/dashboard/src/languages/it-IT.json'
import DutchDash from '@vmockinc/dashboard/src/languages/nl-NL.json'

function mergeTranslations() {
    const mergedFrench = French,
      mergedEnglish = English,
      mergedSpanish = Spanish,
      mergedFrenchCanadian = FrenchCanadian,
      mergedPolish = Polish,
      mergedGerman = German,
      mergedPortuguese = Portuguese,
      mergedItalian = Italian,
      mergedDutch = Dutch

    Object.keys(EnglishDash).forEach(key => {
      if (English[key]) {
        //
      } else {
        mergedEnglish[key] = EnglishDash[key]
        mergedFrench[key] = FrenchDash[key]
        mergedSpanish[key] = SpanishDash[key]
        mergedFrenchCanadian[key] = FrenchCanadianDash[key]
        mergedPolish[key] = PolishDash[key]
        mergedGerman[key] = GermanDash[key]
        mergedPortuguese[key] = PortugueseDash[key]
        mergedItalian[key] = ItalianDash[key]
        mergedDutch[key] = DutchDash[key]
      }
    })
    return {
      mergedEnglish,
      mergedFrench,
      mergedSpanish,
      mergedFrenchCanadian,
      mergedPolish,
      mergedGerman,
      mergedPortuguese,
      mergedItalian,
      mergedDutch,
    }
  }
  
  export function fetchTranslations(parserLang) {
    const {
      mergedEnglish,
      mergedFrench,
      mergedSpanish,
      mergedFrenchCanadian,
      mergedPolish,
      mergedGerman,
      mergedPortuguese,
      mergedItalian,
      mergedDutch,
    } = mergeTranslations()

    switch (parserLang) {
      case 'polish':
        return {
          locale: 'pl-PL',
          messages: mergedPolish,
        }
      case 'german':
        return {
          locale: 'de-DE',
          messages: mergedGerman,
        }
      case 'portuguese':
        return {
          locale: 'pt-PT',
          messages: mergedPortuguese,
        }
      case 'italian':
        return {
          locale: 'it-IT',
          messages: mergedItalian,
        }
      case 'dutch':
        return {
          locale: 'nl-NL',
          messages: mergedDutch,
        }
      case 'french':
        return {
          locale: 'fr-FR',
          messages: mergedFrench,
        }
      case 'french_ca':
        return {
          locale: 'fr-CA',
          messages: mergedFrenchCanadian,
        }
      case 'spanish':
        return {
          locale: 'es-SP',
          messages: mergedSpanish,
        }
      default:
        return {
          locale: 'en-US',
          messages: mergedEnglish,
        }
    }
  }